<template>
  <section id="SectionCitadele" :class="background">
    <Wrap class="lg">
      <h2 class="title">
        {{ $t('title') }}
      </h2>

      <p>{{ $t('text') }}</p>

      <ul class="bulletpoints">
        <li v-for="(item, index) in $ta('bulletpoints')" :key="index">
          {{ item }}
        </li>
      </ul>

      <div class="cta">
        <a
          class="Btn"
          href="https://mano.citadele.lt/sso/auth/realms/citadele-mx/protocol/openid-connect/auth?response_type=code&client_id=consumer-loan-lt-app&state=455fe8f3-29b6-45fd-a2b4-f8db5b2eada5&login=true&scope=openid&redirect_uri=https%3A%2F%2Fmano.citadele.lt%2Fconsumer-loan-lt%2Fsso%2Flogin"
          target="_blank"
          :title="$t('cta')">
          {{ $t('cta') }}
        </a>
      </div>
      <p>{{ $t('text2') }}</p>

      <ul class="bulletpoints">
        <li v-for="(item, index) in bulletpoints2" :key="index" v-html="item" />
      </ul>
    </Wrap>
  </section>
</template>

<script>
export default {
  props: {
    background: String,
    title: String,
  },
  computed: {
    bulletpoints2() {
      // eslint-disable-next-line xss/no-mixed-html
      return this.$ta('bulletpoints2').map(bulletpoint => bulletpoint.replace('[link]', '<a href="https://enmin.lrv.lt/lt/veiklos-sritys-3/atsinaujinantys-energijos-istekliai/elektros-energija-gaminantys-vartotojai" target="_blank">daugiau informacijos galite rasti čia.</a>'))
    },
  },
}
</script>

<style lang="scss">
#SectionCitadele {
  .title {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    font-weight: $bold;
  }

  .bulletpoints {
    margin-top: 1.5rem;
    opacity: 0.8;
    padding-left: 1rem;
  }

  .cta {
    margin: 3rem 0;
    text-align: center;
    @include md {
      margin-top: 4rem;
    }
  }

  .calculatorSide {
    min-width: 300px;
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Pirkimas išsimokėtinai su „Citadele“",
    "text": "Specialus pasiūlymas – paskolai iki 2 000 EUR netaikomas sutarties mokestis*. Pasiūlymas galioja iki rugsėjo 19 d.",
    "bulletpoints": [
      "Asmeninis pasiūlymas: Pildykite paraišką ir per 10 min. gaukite pasiūlymą;",
      "Paskola iki 15 000 EUR; Palūkanų norma nuo 4,9%;",
      "Grąžinimo terminas: Nuo 12 iki 60 mėn."
    ],
    "text2": "Jeigu turite nuosavą namą, ūkinį pastatą ar tau priklausantį žemės sklypą dabar galite pasiskolinti ypač žemomis palūkanomis nuosavos saulės jėgainės įsigijimui ir įrengimui.",
    "bulletpoints2": [
      "Nuosavai saulės jėgainei įsigyti ir įrengti;",
      "Nutolusios saulės elektrinės daliai įsigyti;",
      "Kaip tapti energetiškai nepriklausomu ir elektros energiją gamintis pačiam [link]"
    ],
    "cta": "Pildyti paraišką"
  }
}
</i18n>
